import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Icons from "../components/Layouts/Icons";
import { Link, useLocation, useParams } from "react-router-dom";
import { jsPDF } from "jspdf";
import * as Yup from "yup";

import {
  clearGallery,
  getGalleryImages,
  getFolderDetails,
  setImagesLoading,
  resetGalleryData,
  currentTabHandler,
  customFetchImages,
  clearSelectedAlbum,
  clearImageSuggestion,
  updateShareLinkStatus,
  addImagesToSuggestion,
  downloadWithExtention,
  removeImageFromSuggested,
  updateSuggestedImageCount,
  downloadUserSelectedFiles,
  removeImageFromSuggestion,
  updateImageSuggestionStatus,
  selectedImageListViewToggle,
} from "../store/slices/Gallery/gallerySlice";

import {
  unloclAlbum,
  shareInfoPopup,
  postShareNotification,
} from "../store/slices/Project/ProjectSingle";
import { clearSelectedPhotos } from "../store/slices/UserFlow/userFlowSlice";
import { handleLockAlbumApi } from "../store/slices/Gallery/gallerySlice copy";

const useGallery = () => {
  const dispatch = useDispatch();
  const { folderID, projectID } = useParams();

  const location = useLocation();

  const { sections, currentTab, status, currentFolderDetails, imagesLoading } =
    useSelector((state) => state.gallery);
  const { allFolders, getCurrentProjectDetails } = useSelector(
    (state) => state.projectSinglePage
  );
  const selectedImages = sections?.selected?.data;
  const selectedImageId = selectedImages?.map(
    (item) => item?.images?.original_name
  );
  const { currentPageDetails } = getCurrentProjectDetails;
  const [isShowNotifyModal, setIsShowNotifyModal] = useState(false);

  useEffect(() => {
    if (allFolders.list.plan_payment_status === undefined) {
      handleGetAllProjects();
    }
    if (location?.pathname !== "/dashboard") {
      let obj = {
        url: getUrls("suggested"),
        id: folderID,
        page: 1,
        sort: "desc",
        per_page: 20,
      };
      dispatch(getGalleryImages(obj));
    }
    // hard check this
  }, []);

  // infinite scrolling
  useEffect(() => {
    const obj = {
      url: "/album/album-images",
      id: folderID,
      page: 1,
      sort: "desc",
      per_page: 20,
    };
    if (location?.pathname !== "/dashboard") {
      if (currentTab === "all") {
        getAlbumsItems(obj);
      }
    }
  }, [folderID]);

  const getAlbumsItems = async (obj) => {
    const resultAction = await dispatch(getGalleryImages(obj));
    dispatch(setImagesLoading(true));
    if (getGalleryImages.fulfilled.match(resultAction)) {
      loadMoreData(resultAction?.payload?.data?.result);
    }
  };

  const loadMoreData = async (Albums) => {
    if (Albums?.current_page < Albums.last_page) {
      const obj = {
        url: "/album/album-images",
        id: folderID,
        page: Albums?.current_page + 1,
        sort: "desc",
        per_page: 20,
      };
      if (currentTab === "all") {
        const resultAction = await dispatch(customFetchImages(obj));
        if (customFetchImages.fulfilled.match(resultAction)) {
          loadMoreData(resultAction?.payload?.data?.result);
        }
      }
    } else if (Albums?.current_page == Albums.last_page) {
      dispatch(setImagesLoading(false));
    }
  };

  const getUrls = (slug) => {
    switch (slug) {
      case "all":
        return "/album/album-images";
        break;
      case "selected":
        return "/album/selected-images";
        break;
      case "suggested":
        return "/album/suggested-images";
        break;
    }
  };

  const capitalizeFirstLetter = (string) => {
    if (string === "" || string === undefined) {
      return "";
    } else {
      return string?.charAt(0)?.toUpperCase() + string?.slice(1);
    }
  };

  const handleGetAllProjects = (order = false) => {
    const data = {
      page: "1",
      per_page: 20,
      sort: order == false ? allFolders.filter.order : order,
      project_id: projectID,
    };
    // dispatch(getFoldersByProjectID(data));
  };

  const handleSuggest = (obj) => {
    const { status, image_id, setFavIsSelected } = obj;
    const formData = {
      album: [
        {
          image_id: image_id,
          album_id: folderID,
        },
      ],
    };
    if (status === true) {
      dispatch(addImagesToSuggestion(formData))
        .unwrap()
        .then((res) => {
          if (res.data.success) {
            setFavIsSelected(status);

            dispatch(
              updateSuggestedImageCount(
                res.data?.result?.suggested_images_count
              )
            );

            const newSSArray = [];
            sections?.["all"]["data"]?.forEach((items) => {
              if (items.id == image_id) {
                let album_image =
                  items?.album_image === undefined
                    ? { is_suggested: 0 }
                    : items?.album_image;
                newSSArray.push({
                  ...items,
                  ...{
                    album_image: [
                      {
                        ...album_image[0],
                        ...{ is_suggested: 1 },
                      },
                    ],
                  },
                });
              } else {
                newSSArray.push(items);
              }
            });
            dispatch(clearImageSuggestion());
            dispatch(updateImageSuggestionStatus(newSSArray));
          } else {
            setFavIsSelected(!status);
          }
        });
    } else if (status === false) {
      dispatch(removeImageFromSuggestion(formData))
        .unwrap()
        .then((res) => {
          if (res.data.success) {
            if (currentTab !== "suggested") {
              setFavIsSelected(status);
            }
            dispatch(
              updateSuggestedImageCount(res.data.result.suggested_images_count)
            );

            try {
              let updatedSuggested = sections?.["suggested"]?.["data"]?.filter(
                (items) => {
                  return items.id !== image_id;
                }
              );

              dispatch(removeImageFromSuggested(updatedSuggested));
            } catch (error) {}

            const newSSArray = [];
            sections?.["all"]["data"]?.forEach((items) => {
              if (items.id == image_id) {
                let album_image =
                  items?.album_image === undefined
                    ? { is_suggested: 0 }
                    : items?.album_image;
                newSSArray.push({
                  ...items,
                  ...{
                    album_image: [
                      {
                        ...album_image[0],
                        ...{ is_suggested: 0 },
                      },
                    ],
                  },
                });
              } else {
                newSSArray.push(items);
              }
            });

            dispatch(updateImageSuggestionStatus(newSSArray));
          } else {
            setFavIsSelected(!status);
          }
        });
    }
  };

  const handleGalleryTab = (tabName) => {
    dispatch(currentTabHandler(tabName));
  };

  const isDataLoading = () => {
    if (status === "loading") {
      return true;
    } else {
      return false;
    }
  };

  const handleEventShareInfoPopup = (status) => {
    dispatch(shareInfoPopup(status));
  };

  const getImagesForSection = (slug) => {
    let obj = {
      url: getUrls(slug),
      id: folderID,
      page: 1,
      sort: "desc",
      per_page: 20,
    };

    if (sections[currentTab]?.["order"] != undefined) {
      obj.sort = sections[currentTab]?.["order"];
    }

    if (
      sections?.all?.data == undefined ||
      sections?.selected?.data == undefined ||
      currentFolderDetails?.id !== folderID
    ) {
      dispatch(getGalleryImages(obj))
        .unwrap()
        .then((res) => {});
    }
  };

  const loadMore = (slug, type) => {
    if (type == "others") {
      if (sections["all"]?.current_page < sections["all"]?.last_page) {
        let obj = {
          id: folderID,
          url: getUrls(slug),
          page: sections["all"]?.current_page + 1,
          sort: "desc",
        };

        if (sections[currentTab]?.["order"] != undefined) {
          obj.sort = sections[currentTab]?.["order"];
        }

        dispatch(customFetchImages(obj));
      }
    } else {
      if (
        sections[currentTab]?.current_page < sections[currentTab]?.last_page
      ) {
        let obj = {
          id: folderID,
          url: getUrls(slug),
          page: sections[currentTab]?.current_page + 1,
          sort: "desc",
        };

        if (sections[currentTab]?.["order"] != undefined) {
          obj.sort = sections[currentTab]?.["order"];
        }

        dispatch(customFetchImages(obj));
      }
    }
  };

  const handleSelectedImageListViewToggle = (state) => {
    dispatch(selectedImageListViewToggle(state));
  };

  const handleResetGalleryData = (state) => {
    dispatch(resetGalleryData(state));
  };

  const handleDownloadUserSelectedFiles = (state) => {
    const packet = {
      url: "/download-zip",
      album_id: currentFolderDetails?.id,
    };
    dispatch(downloadUserSelectedFiles(packet))
      .unwrap()
      .then((res) => {
        if (res.data.success === true) {
          const url = res.data.result;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Demo.csv`);
          document.body.appendChild(link);
          link.click();
          // Clean up and remove the link
          link.parentNode.removeChild(link);
        }
      })
      .catch((error) => {});
  };
  const handleDownloadWithExtention = (state) => {
    const packet = {
      url: "/download-extension-zip",
      album_id: currentFolderDetails?.id,
    };
    dispatch(downloadWithExtention(packet))
      .unwrap()
      .then((res) => {
        if (res.data.success === true) {
          const url = res.data.result;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Demo.csv`);
          document.body.appendChild(link);
          link.click();
          // Clean up and remove the link
          link.parentNode.removeChild(link);
        }
      })
      .catch((error) => {});
  };

  // hanan-test
  const doc = new jsPDF();

  const handleDownloadImageId = () => {
    const text = selectedImageId.join("\n");
    const dataToDownload = text;
    const element = document.createElement("a");
    const file = new Blob([dataToDownload], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "Image ID.txt";
    document.body.appendChild(element);
    element.click();
  };

  const handleClearGallery = (state) => {
    dispatch(clearGallery(state));
  };

  const handleUpdateShareLinkStatus = async (status) => {
    let data = {
      id: folderID,
      link_status: status,
    };
    await dispatch(updateShareLinkStatus(data))
      .unwrap()
      .then((data) => {});
  };

  const shareNotificationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password is required.")
      .min(6, "Password length must be a minimum of six."),
  });

  const shareNotificationSubmit = async (data, resetForm, setFieldError) => {
    const resultAction = await dispatch(postShareNotification(data));
    let obj = {
      id: folderID,
      url: "/album/get-album",
    };
    dispatch(getFolderDetails(obj));

    if (postShareNotification.fulfilled.match(resultAction)) {
      toast.success(resultAction?.payload?.data?.message, {
        position: "bottom-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleClearSelectedImages = async () => {
    // album/remove-selection
    let obj = {
      url: getUrls("selected"),
      id: folderID,
      page: 1,
      sort: "desc",
      per_page: 20,
    };
    const resultAction = await dispatch(clearSelectedAlbum({ id: folderID }));
    let data = {
      id: folderID,
      url: "/album/get-album",
    };
    await dispatch(getFolderDetails(data));

    if (clearSelectedAlbum.fulfilled.match(resultAction)) {
      await dispatch(getGalleryImages(obj));

      toast.success("Images has been successfully Cleared", {
        position: "bottom-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleLockModal = () => {
    // if (notifyData == 1) {
    setIsShowNotifyModal(true);
    // }
    // handleLockAlbumApi;
    // if (notifyData == 0 || notifyData === null) {
    //   setIsShowNotifyModal(true);
    // }
  };
  const handleUnlock = async (data) => {
    try {
      const res = await dispatch(unloclAlbum(data)).unwrap();
      if (res?.data?.success && res?.data?.result?.lock_password !== undefined) {
        setIsShowNotifyModal(false);
        let obj = {
          id: folderID,
          url: "/album/get-album",
        };
        await dispatch(getFolderDetails(obj));
        toast.success("Album unlocked in FPA successfully", {
          position: "bottom-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(res?.data?.message || "Failed to unlock album", {
          position: "bottom-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error("Failed to unlock album", {
        position: "bottom-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  const handleLockAlbum = async (data, resetForm) => {
    if (currentFolderDetails?.lock_status === "1") {
      handleUnlock(data);
    } else {
      try {
        const res = await dispatch(handleLockAlbumApi(data)).unwrap();
        if (res?.data?.success) {
          let obj = {
            id: folderID,
            url: "/album/get-album",
          };
          await dispatch(getFolderDetails(obj));
          resetForm();
          toast.success("Album locked in FPA successfully", {
            position: "bottom-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error(res?.data?.message || "Failed to lock album", {
            position: "bottom-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } catch (error) {
        toast.error("Failed to lock album", {
          position: "bottom-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

  return {
    status,
    sections,
    currentTab,
    shareNotificationSchema,
    handleGalleryTab,
    isShowNotifyModal,
    getImagesForSection,
    isDataLoading,
    loadMore,
    handleSelectedImageListViewToggle,
    handleResetGalleryData,
    handleDownloadUserSelectedFiles,
    handleDownloadWithExtention,
    handleDownloadImageId,
    handleClearGallery,
    handleEventShareInfoPopup,
    handleUpdateShareLinkStatus,
    setIsShowNotifyModal,
    shareNotificationSubmit,
    handleUnlock,
    handleSuggest,
    capitalizeFirstLetter,
    handleClearSelectedImages,
    handleLockModal,
    handleLockAlbum,
    currentFolderDetails,
    imagesLoading,
  };
};

export default useGallery;
